import Swal from "sweetalert2";
import api from "./axiosConfig";

/**
 * Show beautiful alert using SweetAlert2
 */
const showAlert = (title: string, text: string, icon: "success" | "error" | "warning" | "info") => {
  Swal.fire({
    title,
    text,
    icon,
    confirmButtonColor: "#1976d2",
  });
};

// Fetch all companies
const getCompanies = async () => {
  try {
    const response = await api.get("/companies");
    console.log("response",response)
    return response.data;
  } catch (error: any) {
    console.error("Error fetching companies:", error);
    showAlert("Error", error.response?.data?.message || "Failed to load companies", "error");
    return [];
  }
};

// Add a new company
const addCompany = async (companyData: any) => {
  try {
    const response = await api.post("/companies", companyData);
    showAlert("Success", "Company added successfully!", "success");
    return response.data;
  } catch (error: any) {
    console.error("Error adding company:", error);
    showAlert("Error", error.response?.data?.message || "Failed to add company", "error");
    return null;
  }
};

// Update an existing company
const updateCompany = async (id: number, companyData: any) => {
  try {
    const response = await api.put(`/companies/${id}`, companyData);
    showAlert("Success", "Company updated successfully!", "success");
    return response.data;
  } catch (error: any) {
    console.error("Error updating company:", error);
    showAlert("Error", error.response?.data?.message || "Failed to update company", "error");
    return null;
  }
};

// Delete a company
const deleteCompany = async (id: number) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#1976d2",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) {
      return null;
    }

    const response = await api.delete(`/companies/${id}`);
    showAlert("Success", "Company deleted successfully!", "success");
    return response.data;
  } catch (error: any) {
    console.error("Error deleting company:", error);
    showAlert("Error", error.response?.data?.message || "Failed to delete company", "error");
    return null;
  }
};

export { getCompanies, addCompany, updateCompany, deleteCompany };
